module.exports = __webpack_public_path__ + "img/home_pdd.9e279654.png";